// The "time on this contact" chip's arithmetic (ActiveContactTimer.jsx), pure
// so it's unit-testable: elapsed time on the claim minus the time it spent
// parked (2026-10-08), floored at 0, and the chip's MM:SS / H:MM:SS text.

export function elapsedOnContact(now, assignedAt, parkedMs = 0) {
  return Math.max(0, now - assignedAt - (Number(parkedMs) || 0))
}

export function formatElapsed(ms) {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000))
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  const mm = String(minutes).padStart(2, '0')
  const ss = String(seconds).padStart(2, '0')
  return hours > 0 ? `${hours}:${mm}:${ss}` : `${mm}:${ss}`
}
